export default __webpack_public_path__ + "static/lsa-specs-90fc1e075e6bbd2607d6ca626bfb888c.jpg";